import { render, staticRenderFns } from "./RequestActivationEmailPage.vue?vue&type=template&id=0ab8491c&scoped=true&"
import script from "./RequestActivationEmailPage.vue?vue&type=script&lang=js&"
export * from "./RequestActivationEmailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8491c",
  null
  
)

export default component.exports